<div class="generic-cfl">
    <h2 mat-dialog-title class="dialog-title text-center fs-5">E-Way Bill Generation</h2>

    <mat-dialog-content class="mat-typography">
        <p>Do you want to generate E-WayBill now or later?</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end" class="dialog-actions">
        <button mat-stroked-button color="primary" [mat-dialog-close]="true">Now</button>
        <button mat-stroked-button color="primary" [mat-dialog-close]="false">Later</button>
        <button mat-stroked-button color="primary" [mat-dialog-close]="">Cancel</button>
    </mat-dialog-actions>
</div>